import { Editor, Extension } from "@tiptap/core";
import { ReactRenderer } from "@tiptap/react";
import Suggestion from "@tiptap/suggestion";
import tippy from "tippy.js";

import { tooltipZIndex } from "@helpers/constants";

import SkillCommandsList from "./skill-commands-list";

type SkillItem = { name: string; description: string };

type Options = {
  items: (args: { query: string }) => SkillItem[];
};

const renderSuggestion = () => {
  let component: any;
  let popup: any;

  return {
    onStart: (props: any) => {
      component = new ReactRenderer(SkillCommandsList, {
        props,
        editor: props.editor,
      });
      popup = tippy("body", {
        getReferenceClientRect: props.clientRect,
        appendTo: () => document.body,
        content: component.element,
        showOnCreate: true,
        interactive: true,
        trigger: "manual",
        placement: "bottom-start",
        theme: "headless",
        zIndex: tooltipZIndex,
      });
    },
    onUpdate(props: any) {
      component.updateProps(props);
      popup[0].setProps({ getReferenceClientRect: props.clientRect });
    },
    onKeyDown(props: any) {
      if (props.event.key === "Escape") {
        popup[0].hide();
        return true;
      }
      return component.ref?.onKeyDown(props);
    },
    onExit() {
      if (popup[0] && !popup[0].state.isDestroyed) popup[0].destroy();
      component.destroy();
    },
  };
};

const SkillCommands = Extension.create<Options>({
  name: "skillCommand",
  priority: 200,
  addOptions() {
    return {
      items: () => [],
    };
  },
  addProseMirrorPlugins() {
    const items = this.options.items;
    return [
      Suggestion({
        editor: this.editor,
        char: "/",
        startOfLine: true,
        items,
        command: ({
          editor,
          range,
          props,
        }: {
          editor: Editor;
          range: any;
          props: { id: string };
        }) => {
          editor
            .chain()
            .focus()
            .deleteRange(range)
            .insertContent(`/${props.id} `)
            .run();
        },
        render: renderSuggestion,
      }),
    ];
  },
});

export default SkillCommands;
